import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Row, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import Layout from "../../hocs/Layout";
import VirtualBattery from "../../components/bateriaVirtual/VirtualBattery";
import { get_datos_oferta_erp } from "../../services/ofertas";
import { save_bateria_virtual } from "../../services/bateriaVirtual";
import { includesBvLabel } from "../../utils/bateriaVirtual";
import OfferWizardWrapper from "../../components/ofertas/OfferWizardWrapper";
import { useOfferWizard } from "../../components/ofertas/OfferWizardContext";

const VirtualBatteryScreenContent = () => {
  const { sector_type, oferta_id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const bateriaVirtualRef = useRef(null);
  const { setActionHandler, setIsSubmitting } = useOfferWizard();
  const [oferta, setOferta] = useState(null);
  const llistaPreuGlobal =
    oferta?.llista_preu_global ||
    oferta?.crm_polissa?.llista_preu_global ||
    oferta?.crm_polissa?.llista_preu;
  const autoconsumoValue = oferta?.autoconsumo;
  const hasAutoconsumo = autoconsumoValue === "41" || autoconsumoValue === "42" || autoconsumoValue === "43";
  const showVirtualBattery = (hasAutoconsumo && includesBvLabel(llistaPreuGlobal)) && !!oferta?.bateria_virtual;
  // const hasAutoconsumo =
  //   autoconsumoValue !== null &&
  //   autoconsumoValue !== undefined &&
  //   String(autoconsumoValue).trim() !== "" &&
  //   String(autoconsumoValue) !== "00";
  // const showVirtualBattery =
  //   (hasAutoconsumo && includesBvLabel(llistaPreuGlobal)) ||
  //   (oferta?.bateria_virtual && Object.keys(oferta.bateria_virtual).length > 0);
  const cupsOrigenName = oferta?.cups_name || oferta?.cups_global || "";

  const initialDestinos = useMemo(() => {
    if (!oferta) return [];
    const destinos =
      oferta?.bateria_virtual_destino_ids ||
      oferta?.bateria_virtual_destinos ||
      [];
    return destinos.map((destino) => ({
      cupsDestino: destino?.cups_destino || destino?.cupsDestino || "",
      porcentaje:
        destino?.porcentaje !== undefined && destino?.porcentaje !== null
          ? String(destino.porcentaje)
          : "",
      cupsDestinoName:
        destino?.cups_destino_name ||
        destino?.cupsDestinoName ||
        destino?.cupsDestino ||
        "",
    }));
  }, [oferta]);

  const parsedOfertaId = Number(oferta_id);
  const ofertaIdValue =
    oferta?.id ?? (Number.isNaN(parsedOfertaId) ? oferta_id : parsedOfertaId);

  const handleSave = async () => {
    if (!showVirtualBattery) {
      return;
    }

    if (typeof document !== "undefined" && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    const payload = bateriaVirtualRef.current?.getPayload?.();
    if (!payload) {
      return;
    }

    setIsSaving(true);
    try {
      await save_bateria_virtual({
        ...payload,
        oferta_id: ofertaIdValue,
        sector_type,
      });
      toast.success("Batería virtual guardada correctamente.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const loadOferta = async () => {
      const datos = await get_datos_oferta_erp(oferta_id);
      setOferta(datos);
    };
    loadOferta();
  }, [oferta_id]);

  useEffect(() => {
    setIsSubmitting(isSaving);
  }, [isSaving, setIsSubmitting]);

  useEffect(() => {
    setActionHandler({
      onSave: handleSave
    });
  }, [setActionHandler, handleSave]);



  return (

    <div className="py-5 bg-light min-vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <Card className="border-0 shadow-lg rounded-4 overflow-hidden">
              <Card.Header className="bg-white border-bottom-0 pt-4 pb-0 text-center">
                <h2 className="text-primary fw-bold mb-0">Gestión Batería Virtual</h2>
              </Card.Header>
              <Card.Body className="p-4 p-md-5">
                {!oferta && (
                  <p className="mb-0 text-muted text-center">
                    Cargando datos de la oferta...
                  </p>
                )}
                {oferta && !showVirtualBattery && (
                  <div className="alert alert-warning text-center">
                    Esta oferta no cumple los requisitos para gestionar la batería virtual.
                  </div>
                )}
                {oferta && showVirtualBattery && (
                  <VirtualBattery
                    ref={bateriaVirtualRef}
                    sectorType={sector_type}
                    cupsOrigenName={cupsOrigenName}
                    initialDestinos={initialDestinos}
                    ofertaId={ofertaIdValue}
                  />
                )}
              </Card.Body>
              {/* Footer removed, actions handled by Wizard */}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const VirtualBatteryScreen = (props) => {
  const { sector_type, oferta_id } = useParams();
  return (
    <Layout
      offerContext={{ sector_type, oferta_id }}
    >
      <OfferWizardWrapper currentStep="bateria-virtual">
        <VirtualBatteryScreenContent {...props} />
      </OfferWizardWrapper>
    </Layout>
  );
};

export default VirtualBatteryScreen;
